import { logoutClaveUnica } from "../../components/service/service.supersalud";

// const stringUser={};
const stringUser = sessionStorage.getItem("user") || null;
const initialState = JSON.parse(stringUser);

const loginOut = async ()=>{
    const resp = await logoutClaveUnica();
}

const user = (state = initialState, { user = {}, type }) => {
    let expirationDate = new Date(new Date().getTime() + 60000 * 1);
    const { auth } = user;
    switch (type) {
        case 'signIn':
            const data = { ...state, ...user, ...(auth && { auth }), expirationDate };
            
            sessionStorage.setItem("user", JSON.stringify(data));
            return data;

        case 'logOut':
            let _user = sessionStorage.getItem("user");
            _user = JSON.parse(_user);
            sessionStorage.removeItem("user");
            loginOut()
            return null;

        default:
            return state
    }

};

export default user;
